import React, {Component} from 'react';
import { connect } from 'react-redux';
import { receiveWaitingMembers } from '../../../actions/setting/teamblog'
import * as RoleType from "../../../constants/user/RoleType";

@connect(state => ({
    currentUserRole : state.user.role,
}), (dispatch) => ({
    handleReceiveWaitingMembers: (items) => {
        dispatch(receiveWaitingMembers(items))
    }
}))
class TeamBlogWaitingList extends Component {

    constructor(props){
        super(props);

        this.renderCancelInviteButton = this.renderCancelInviteButton.bind(this);
        this.cancelInvite = this.cancelInvite.bind(this);
    }

    cancelInvite(invitation) {

        const { waitingMembers } = this.props;

        if(confirm('초대를 취소하시겠습니까?')){
            fetch("/manage/teamblog/invitation/"+invitation.id+".json", {
                method: 'delete',
                credentials: 'include'
            })
                .then(r => r.json())
                .then(data => {
                    let newItems = waitingMembers.filter((item) => (item.id !== invitation.id));

                    this.props.handleReceiveWaitingMembers(newItems);
                })
                .catch(e => {
                    this.props.handleReceiveWaitingMembers([]);
                })
        }
    }


    render() {

        const { waitingMembers } = this.props;

        return (
                <div className="wrap_list waiting_list">
                    <ul className="list_post">
                        {
                            waitingMembers.map((item) => (<li>
                                <div className="post_cont">
                                    <span className="wrap_thumb empty_thumb">
                                        <img src={item.userImage} width="36" height="36" className="thumb_img" alt="" onError={(e) => this.setDefaultProfileImage(e)}/>
                                    </span>
                                    <strong className="tit_post txt_ellip">
                                        <span className="link_cont">{item.userName}</span>
                                        <span className="txt_etc">{item.userLoginId}</span>
                                    </strong>
                                </div>
                                <span className="post_etc post_date">
                                    초대<span className="txt_etc">{item.suggested}.</span>
                                </span>
                                <span className="post_etc post_date">
                                    기한<span className="txt_etc">{item.expired}.</span>
                                </span>
                                { this.renderCancelInviteButton(item) }
                            </li>))
                        }
                    </ul>
                </div>
        );
    }

    setDefaultProfileImage(e) {
        e.target.src="//t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png";
    }

    renderCancelInviteButton(item) {

        const { currentUserRole } = this.props;

        const cancelInvitationRequireRole = RoleType.MANAGER;

        if(RoleType.canAccess(RoleType.convertStringToRoleType(currentUserRole), cancelInvitationRequireRole)) {
            return <span className="post_etc post_cancle">
                        <label className="lab_btn btn_cancel">
                            초대 취소
                            <input type="button" className="btn_g" value="초대취소"
                                   onClick={(e) => this.cancelInvite(item)}/>
                        </label>
                    </span>
        }
        return null;
    }
}

export default TeamBlogWaitingList;
